import { Transform } from "class-transformer";

export default class LastPrice {

  @Transform(({ value }) => value && value.toISOString(), { toPlainOnly: true })
  @Transform(({ value }) => value && new Date(value), { toClassOnly: true })
  priceDate: Date

  @Transform(({ value }) => value && value.toISOString(), { toPlainOnly: true })
  @Transform(({ value }) => value && new Date(value), { toClassOnly: true })
  updatedAt: Date

  /**
   * @param securityId The id of the security that this price refers to.
   * @param price The price value.
   * @param priceDate The date and time that this price refers to.
   * @param updatedAt The date and time when this price was updated.
   */
  constructor(
    public securityId: string,
    public price: number,
    priceDate: Date,
    updatedAt: Date
  ) {
    this.priceDate = priceDate;
    this.updatedAt = updatedAt;
  }
}